import styled from "styled-components";

export const LinkContainer = styled.div`
  margin-top: ${props => props.theme.spacerxl};
`;
